'use client'

import React, { useEffect } from 'react';
import { AppContext, contextReducer } from '@context/AppContext';
import type { IContext } from "msgdsk-types";
import { useImmerReducer } from "use-immer";

import { NextPage } from "next"

import { log } from '@libs/utilsMsg';

type AppProps = { appStates:IContext, children:React.ReactNode; };
// type AppProps = { sess_id: string; sess:Session; msg:IMsg; domain: string;};
// type AppProps = { scheme: string; domain: string; sessId: string; codeKey:string; };

// const fetcher = (...args) => fetch(...args).then(res => res.json());


const RootLayoutClient: NextPage<AppProps> = ({ appStates, children }) => {
	const [context_data, dispatchContext] = useImmerReducer(contextReducer, appStates);

	log("RootLayoutClient", context_data);

	useEffect(() => {
		const handleResize = () => dispatchContext({ type: "SET", app: {
			width: window.innerWidth,
			isCompact: context_data.app.widthCompact < window.innerWidth
		}});

		if (!context_data.origin?.[2]) {
			const scheme = window.location.protocol.replace(':', '');
			const domain = window.location.host;
			dispatchContext({ type: "SET", domain });
			dispatchContext({ type: "SET", origin: [scheme, domain, `${scheme}://${domain}`, `${scheme}://xyz.${domain}`] });
		}
		
		handleResize();
		window.addEventListener("resize", handleResize);
		
		return () => window.removeEventListener("resize", handleResize); 
	}, [])
	
	return (		
		<AppContext.Provider value={{ context_data, dispatchContext }}>{children}</AppContext.Provider>
	);
}

export default RootLayoutClient;

/*<AppProvider value={{ context_data, dispatchContext }}>{children)</AppProvider>		 */
